<template>
	<section>
		<el-drawer placement="right" :wrapperClosable="false" :visible="visible1" size="80%" :show-close="false"
			class="drawer">
			<div slot="title">
				<el-button size="small" @click="closeTileVisible">关闭</el-button>
				<template v-if="currentPage && data.is_edit==1">
					<el-switch style="margin-left:30px" v-model="currentPage.isComplete" @change="onCompleteChange">
					</el-switch>
					<span style="font-size:14px;margin-right:20px">{{currentPage.isComplete?'已完成':'未完成'}}</span>
					<el-button type='text' v-if="!currentPage.isComplete" @click="remarkVisible=true"
						icon="el-icon-edit" size='medium'>备注
					</el-button>
					<span v-if="!currentPage.isComplete"
						style="margin-left:5px;font-size:14px;color:#E6A23C">{{currentPage.remark}}</span>
				</template>
			</div>
			<iframe v-if="visible1" :src="h5_pages" name="myIframe1" ref="myIframe1" id="myIframe1" class="ifram1"
				frameborder="6"></iframe>
		</el-drawer>
		<remark v-if="remarkVisible" :book_id="data.book_id" :index="currentPage.index" :txt="currentPage.remark"
			@close="remarkVisible=false" @success="onRemarkSuccess" />
	</section>
</template>

<script>
	import { mapState } from "vuex";
	import { book_index } from '@/api/book'
	import Remark from '../../views/book/remark.vue';
	export default {
		data() {
			return {
				visible1: false,
				remarkVisible: false,
				base_url: process.env.book_preview_url,
				h5_pages: "",
				swipe_index: 0,
				data: {},
				book: {},
				currentPage: null
			};
		},
		computed: {
			...mapState("user", ["innerHeight"]),
			...mapState("book", ["bookSize"])
		},

		components: { Remark },

		methods: {
			onRemarkSuccess(txt) {
				this.remarkVisible = false
				this.currentPage.remark = txt
				this.$forceUpdate()
				this.$emit('change', this.data)
			},
			reGet(page) {
				this.swipe_index = page;
				this.getBook().then(res=>{
					this.currentPage = this.book.list[page]
					this.currentPage.index = page
				})
				this.h5_pages =
					`${this.base_url}/book/` +
					this.data.book_id +
					"?is_edit=1&page_index=" +
					this.data.page_index +
					"&swipe_index=" +
					this.swipe_index +
					"&is_where=" +
					this.data.is_where +
					"&width=" +
					this.bookSize.width +
					"&height=" +
					this.bookSize.height;
				window.open(
					document.getElementById("myIframe1").src,
					"myIframe1",
					""
				); //强制刷新iframe ，用document会产生跨域问题
			},

			openTileVisible(data, type) {
				this.visible1 = true;
				let that = this;
				if (type == "see") {
					//仅查看本地数据
					this.h5_pages = `${this.base_url}/see?is_edit=0&is_where=2&width=${this.bookSize.width}&height=${this.bookSize.height}`;
					let timer = setInterval(() => {
						if (document.getElementById("myIframe1")) {
							document.getElementById("myIframe1").onload = _ => {
								document.getElementById("myIframe1").contentWindow.postMessage(data, that.h5_pages);
							};
							clearInterval(timer);
						}
					}, 10);
				} else {
					this.data = data;
					this.h5_pages = `${this.base_url}/book/${data.book_id}?is_edit=${data.is_edit}&page_index=${data.page_index}&is_where=${data.is_where}&width=${this.bookSize.width}&height=${this.bookSize.height}`;
					if (data.is_edit == 1) {
						this.$store.commit("book/updateIsAll", false); //标记是否整体编辑
						window.addEventListener("message", this.onAction, false);
					}
					this.getBook()
				}
			},
			getBook() {
				return  book_index.findOne({ book_id: this.data.book_id }).then(res => {
					this.book = res.data
					return true
				})
			},
			onAction(e) {
				if (e.data.action == 'pageChange') {
					this.onPageChange(e.data.page)
				} else if (e.data.action == 'updatePage') {
					this.$store.dispatch("book/saveItem", {
						book_id: this.book.id,
						book_page_index: e.data.data.page_index,
						book_page: { data: e.data.data.list }
					}).then(res => {
						this.$message({ message: "保存成功！", type: "success" });
					});

				} else if (e && e.data && e.data.book_id) {
					if (this.visible1) {
						let item = e.data;
						this.$parent.openEdit(item);
					}
				}
			},
			onPageChange(page) {
				this.currentPage = this.book.list[page]
				if (this.currentPage) {
					this.currentPage.index = page
				}
			},
			closeTileVisible() {
				this.visible1 = false;
				this.currentPage = null
				window.removeEventListener('message', this.onAction)
				this.$emit("closeTileVisible");

			},
			onCompleteChange(e) {
				book_index.setComplete({
					book_id: this.data.book_id,
					book_page_index: this.currentPage.index,
					complete: e
				}).then(res => {
					this.$emit('change', this.data)
					document.getElementById("myIframe1").contentWindow.postMessage({
						book_id: this.data.book_id,
						book_page_index: this.currentPage.index,
						complete: e
					}, this.h5_pages);

				})

			}
		},
		mounted() {

		}
	};
</script>

<style scoped lang="scss">
	.ifram1 {
		width: 100%;
		height: 100%;
		align-items: center;
	}
	.drawer /deep/ .el-drawer__body {
		overflow: scroll;
	}
</style>


// WEBPACK FOOTER //
// src/components/book/previewTpl.vue